import { track } from "../track";

export const trackAvatarVideoUploadFail = (params: { error: string }) =>
  track({ event: "avatar_video_upload_fail", ...params });
